import { render } from "./KitchenDisplayAverageOrderTime.vue?vue&type=template&id=0641e452"
import script from "./KitchenDisplayAverageOrderTime.vue?vue&type=script&lang=js"
export * from "./KitchenDisplayAverageOrderTime.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__